import { useMutation, UseMutationResult } from 'react-query';
import { MutationError } from 'src/core/type';
import {
  editChildData,
  getChildData,
  getChildList,
  getCreateChild,
} from './services';
import {
  childDataRequest,
  childListResponse,
  insertChildRequest,
} from './types';

export const useInsertChild = (): UseMutationResult<
  any,
  MutationError,
  insertChildRequest
> => {
  return useMutation({
    mutationFn: (variables: insertChildRequest) => {
      return getCreateChild(variables);
    },
  });
};

export const useChildList = (): UseMutationResult<
  childListResponse[],
  MutationError,
  any
> => {
  return useMutation({
    mutationFn: () => {
      return getChildList();
    },
  });
};

export const useChildInfo = (
  params: number,
): UseMutationResult<any, MutationError> => {
  return useMutation({
    mutationFn: (variables) => {
      return getChildData(variables);
    },
  });
};

export const useUpdateChild = (): UseMutationResult<
  any,
  MutationError,
  childDataRequest
> => {
  return useMutation({
    mutationFn: (variables: childDataRequest) => {
      return editChildData(variables);
    },
  });
};
